/* Shared helpers and small components loaded on every page. */
window.OlyJoy = {
  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  },

  debounce(fn, wait) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), wait);
    };
  },

  /* Parses a Section Rendering API response and returns the element matched by selector. */
  parseSectionHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  },
};

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button[name]');
      if (!button) return;
      event.preventDefault();
      const previous = this.input.value;
      if (button.name === 'plus') this.input.stepUp();
      if (button.name === 'minus') this.input.stepDown();
      if (previous !== this.input.value) this.input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}
customElements.define('quantity-input', QuantityInput);

/* Forms with data-auto-submit submit when any control inside changes (used for collection sort). */
document.addEventListener('change', (event) => {
  const form = event.target.closest('form[data-auto-submit]');
  if (form) form.requestSubmit();
});
